import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-category-page-two',
  templateUrl: './category-page-two.component.html',
  styleUrls: ['./category-page-two.component.scss']
})
export class CategoryPageTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
